import React from 'react';
import Heading from '../components/heading';
import * as Render from '../platformui/Base/Render';
import { isSmallViewport } from '../platformui/Hooks/useMedia';
import ZoomContainer from '../platformui/ZoomContainer/index';

const TableContent = (props) => {
  const tableOverflowClass =
    props.Heading || props.Description
      ? 'table-overflow table-overflow--has-caption'
      : 'table-overflow';
  const tableHeadingClass =
    props.Heading && props.Description
      ? 'table__heading table__heading--with-description'
      : 'table__heading';

  return (
    <div className={tableOverflowClass}>
      {(props.Heading || props.Description) && (
        <caption className="table__caption">
          {props.Heading && (
            <Heading
              className={tableHeadingClass}
              HeadingLevel={props.HeadingLevel}
              Heading={props.Heading}
              PropertyName="Heading"
            />
          )}
          {props.Description && (
            <p className="table__description">
              {Render.Property(props.Description, 'Description')}
            </p>
          )}
        </caption>
      )}
      {props.Table && (
        <div className="table__body">
          {Render.PropertyAsHTML(props.Table, 'Table')}
        </div>
      )}
      {props.Footnote && (
        <p className="table__footer">
          {Render.Property(props.Footnote, 'Footnote')}
        </p>
      )}
    </div>
  );
};

const TableBlock = (props) => {
  const dataPrintSidebarTitle = props.Heading + ' (Tabell)' || 'Tabell';
  return (
    <div
      className="table-block"
      data-print-sidebar-title={dataPrintSidebarTitle}
      data-is-member-of-chapter-container={
        props.isMemberOfChapterContainer || 'false'
      }
    >
      {props.Table && (isSmallViewport() || !props.HasTableZoom) ? (
        <TableContent {...props} />
      ) : (
        props.Table && (
          <ZoomContainer
            id={props?.BlockId.toString()}
            showCloseModalText={true}
            showOpenModalText={true}
            OpenZoomButtonText={
              props.CurrentPageProps.Content?.Translations?.expandtable
            }
          >
            <TableContent {...props} />
          </ZoomContainer>
        )
      )}
    </div>
  );
};

export default TableBlock;
